function calculateDays(P: number, R: number, i: number) {
    // Ensure P, R, and i are valid
    if (P <= 0 || R <= 0 || i <= 0 || R <= P * i) {
        throw new Error(
            'Invalid inputs: Ensure R > P * i, and P, R, and i are greater than zero.'
        );
    }
    //Calculate the number of repayment periods (N)
    const logRepaymentRatio = Math.log(R / (R - P * i));
    const logInterestFactor = Math.log(1 + i);
    const numberOfPeriods = logRepaymentRatio / logInterestFactor;
    return numberOfPeriods;
}

function calculateAdditionalFeeAmount(
    dailyInvestmentAmount: number,
    dailyInterestRate: number,
    numberOfDays: number
) {
    // Ensure inputs are valid
    if (
        dailyInvestmentAmount <= 0 ||
        dailyInterestRate <= 0 ||
        numberOfDays <= 0
    ) {
        throw new Error('Invalid inputs: inputs must be greater than zero.');
    }
    // Calculate the final amount
    const here =
        (Math.pow(1 + dailyInterestRate, numberOfDays) - 1) / dailyInterestRate;
    const additionalFeeAmount = dailyInvestmentAmount * here;
    return additionalFeeAmount;
}

export const getOriginalPricing = ({
    numberOfRepayments,
    totalCreditAmount,
    totalPayable
}: {
    numberOfRepayments: number;
    totalCreditAmount: number;
    totalPayable: number;
}) => {
    //This function gets the original price that an RBL would have gotten if
    //they were to receive our max interest rate of 2.5%.

    const monthlyRate = 0.025; //max interest rate for DE currently
    const dailyRate = monthlyRate / 30; // Convert monthly rate to daily rate

    const repaymentAmount = totalPayable / numberOfRepayments; //Calculate repayment amount per period

    const daysToRepay = calculateDays(
        totalCreditAmount,
        repaymentAmount,
        dailyRate
    ); //Calculate the number of days to repay the loan

    const rateFactor = (1 + dailyRate) / dailyRate; // Factor that adjusts based on rate
    const repaymentFactor = 1 - 1 / Math.pow(1 + dailyRate, daysToRepay + 1); // Factor based on number of repayments
    const denominator = rateFactor * repaymentFactor - 1; // Complete denominator calculation
    const fee = daysToRepay / denominator - 1; // Final fee calculation

    const additionalFeeAmount = calculateAdditionalFeeAmount(
        0.17, // RBL daily fee
        dailyRate,
        daysToRepay
    );

    const originalFeeAmount = fee * totalCreditAmount + additionalFeeAmount;

    return originalFeeAmount;
};
